import { useState } from 'react';

import { useMutation } from "@apollo/client/react";
import {
	DialogTitle,
	DialogActions,
	DialogContent,
	Button,
} from 'components/dialogs/DialogBox';

import ErrorMessage from 'components/ErrorMessage';

import Form from 'web/form/Form';
import { CitizenshipAutocomplete } from 'web/components/user/UserInputFields';

import { VERIFY_ONE_USER_CITIZENSHIP } from 'api/mutations/userMutations';

export default function CitizenshipVerifyModal({
	_id,
	verificationCitizenship,
}) {
	const [error, setError] = useState(null);

	const [verifyUserCitizenship, { loading, error: verifyError }] =
		useMutation(VERIFY_ONE_USER_CITIZENSHIP, {
			refetchQueries: ['currentUser'],
		});
	const handleSubmit = async ({ citizenship }) => {
		try {
			if (!citizenship) {
				setError(
					'Land for statsborgerskap er påkrevd. Vennligst velg et land.'
				);
				return;
			}

			verifyUserCitizenship({
				variables: {
					_id,
					citizenship,
				},
			});
		} catch (err) {
			console.warn(err);
		}
	};

	return (
		<>
			<DialogTitle id="user-verification-dialog-title">
				Vennligst bekreft ditt statsborgerskap
			</DialogTitle>

			<ErrorMessage errors={[error, verifyError]} />

			<Form
				values={{ citizenship: verificationCitizenship }}
				onSubmit={handleSubmit}
			>
				<DialogContent>
					<CitizenshipAutocomplete />
				</DialogContent>

				<DialogActions>
					<Button
						variant="contained"
						color="primary"
						type="submit"
						loading={loading}
					>
						Bekreft statsborgerskap
					</Button>
				</DialogActions>
			</Form>
		</>
	);
}
